import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore } from '../store';
import {
  loadDocumentAndContent,
  resetDecoratorsState,
} from '../modules/wk-document-decorator';
import { DecoratorsTrackChangeConstant as DTC } from '../modules/wk-document-decorator/const';
import { LocalStorage } from '../shared';

export const contentResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot
) => {
  const store = inject<Store<AppStore>>(Store);
  const itemId = route.paramMap.get('nodeId');
  [
    LocalStorage.CURRENT_USER,
    LocalStorage.CURRENT_LHP_SCROLLED_ID,
    DTC.TRACK_CHANGES_AND_COMMENTS_DATA,
    DTC.TRACK_CHANGES_AND_COMMENTS_INVOLVED_USERS,
  ].forEach((key) => localStorage.removeItem(key));
  store.dispatch(resetDecoratorsState());
  store.dispatch(loadDocumentAndContent({ id: itemId, url: '' }));
  return null;
};
